// extracted by mini-css-extract-plugin
export default {"container":"oUouhcar","content":"jQoj4ezd"};